/**
 * GS8 — the attribute `sticky-offset.client.tsx` finds the pinned header by, so it can measure the
 * band it occupies and publish it to the sections below as `--cl-section-offset`.
 */
export const STICKY_HEADER_ATTRIBUTE = "data-cl-sticky-header";
